import React from 'react';
import styles from './styles.module.scss';
import { CircledArrowIcon } from 'assets/icons/CircledArrowIcon';

export const CircledArrowTop = () => (
    <div className={styles.CircledArrowTop}>
      <CircledArrowIcon primary down x2 />
    </div>
);
